import styled, { css } from 'styled-components';

export const ModalDescription = styled.p`
  margin: 0 0 1rem;
  font-size: 0.9rem;
  color: #767676;
  line-height: 1.45;
`;

export const Toolbar = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  margin-bottom: 0.75rem;
`;

export const SearchWrapper = styled.div`
  flex: 1;
  min-width: 200px;
`;

export const SelectionSummary = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  flex-wrap: wrap;
`;

export const SummaryBadge = styled.span`
  display: inline-flex;
  align-items: center;
  padding: 0.2rem 0.55rem;
  border-radius: 999px;
  background: rgba(89, 36, 155, 0.1);
  color: ${props => props.theme.main.color};
  font-size: 0.78rem;
  font-weight: 600;
  white-space: nowrap;
`;

export const SelectAllButton = styled.button`
  border: none;
  background: transparent;
  padding: 0.25rem 0.35rem;
  color: ${props => props.theme.main.color};
  font-size: 0.82rem;
  font-weight: 600;
  cursor: pointer;
  border-radius: 6px;
  white-space: nowrap;

  &:hover:not(:disabled) {
    background: rgba(89, 36, 155, 0.08);
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  &:focus-visible {
    outline: 2px solid ${props => props.theme.main.color};
    outline-offset: 2px;
  }
`;

export const CandidateList = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
  border: 1px solid rgba(34, 36, 38, 0.12);
  border-radius: 8px;
  max-height: 320px;
  overflow-y: auto;
  background: #fff;
`;

export const CandidateListItem = styled.li<{ $selected?: boolean }>`
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.75rem 0.875rem;
  border-bottom: 1px solid rgba(34, 36, 38, 0.08);
  cursor: pointer;
  transition: background-color 0.15s ease;

  &:last-child {
    border-bottom: none;
  }

  ${({ $selected }) =>
    $selected &&
    css`
      background: rgba(89, 36, 155, 0.06);
    `}

  &:hover {
    background: ${({ $selected }) =>
      $selected ? 'rgba(89, 36, 155, 0.1)' : 'rgba(34, 36, 38, 0.04)'};
  }

  .ui.checkbox {
    flex-shrink: 0;
  }

  .ui.checkbox label {
    padding-left: 1.35rem;
  }

  .ui.checkbox label:before,
  .ui.checkbox label:after {
    pointer-events: none;
  }
`;

export const CandidateAvatar = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: #f0edf5;
  color: ${props => props.theme.main.color};
  font-size: 0.8rem;
  font-weight: 700;
  flex-shrink: 0;
`;

export const CandidateInfo = styled.div`
  min-width: 0;
  flex: 1;
`;

export const CandidateName = styled.div`
  font-size: 0.92rem;
  font-weight: 600;
  color: #2b313c;
  line-height: 1.3;
`;

export const CandidateEmail = styled.div`
  font-size: 0.8rem;
  color: #767676;
  margin-top: 0.1rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const EmptyListState = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 2rem 1rem;
  border: 1px dashed rgba(34, 36, 38, 0.15);
  border-radius: 8px;
  color: #767676;
  font-size: 0.9rem;
  line-height: 1.45;
`;

export const LoadingWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 180px;
`;
